import React from 'react'

import * as css from './LiderDetalles.css'
//Componentes
import { RowLiderDetalles } from './RowLiderDetalles.jsx'

export class TablaLiderDetalles extends React.Component{
    constructor(props){
        super(props)
        this.rows = []
    }
    focusRow(index, nombreElemento){
        let ultimoIndex = this.rows.length
        let elemento = nombreElemento
        if(index<0){
            // al seleccionar "antes de la primera", se seleciona el ultimo
            this.rows[ultimoIndex].focusElemento(elemento)
        }else if(index>=ultimoIndex){
            // al seleccionar "despues de la ultima", se selecciona el primero de la siguiente columna
            if(elemento==='inputColacion')
                elemento = 'inputViatico'
            else if(elemento==='inputViatico')
                elemento = 'inputMedioViatico'
            else if(elemento==='inputMedioViatico')
                elemento = 'inputIdComunaOrigen'
            else if(elemento==='inputIdComunaOrigen')
                elemento = 'inputIdComunaSecundaria'
            else if(elemento==='inputIdComunaSecundaria')
                elemento = 'inputColacion'
            this.rows[0].focusElemento(elemento)
        }else{
            // no es ni el ultimo, ni el primero
            this.rows[index].focusElemento(elemento)
        }
    }
    render() {
        let cantidadLideres = this.props.lideres.length
        return (
            <div>
                {cantidadLideres > 0?
                        <TablaLiderDetalle>
                            {_.range(0, cantidadLideres).map(index=>{
                                let lider = this.props.lideres[index]
                                return <RowLiderDetalles
                                    key={index}
                                    index={index}
                                    ref={ref=>this.rows[index]=ref}
                                    focusRow={this.focusRow.bind(this)}
                                    lider={lider}
                                    comunas={this.props.comunas}
                                />
                            })}
                        </TablaLiderDetalle>
                    :
                        <label>Cargando líderes...</label>
                }
            </div>
        )
    }
}
let TablaLiderDetalle = ({children}) =>
    <div className={'panel panel-primary'}>
        <div className={'panel-heading'}><span className="glyphicon glyphicon-list"></span> Detalles</div>
        <div>
            <table className={"table table-bordered table-condensed table-striped"+css.tableFixed}>
                <colgroup>
                    <col className={css.colRut}/>
                    <col className={css.colNombre}/>
                    <col className={css.colColacion}/>
                    <col className={css.colViatico}/>
                    <col className={css.colViatico}/>
                    <col className={css.colOrigen}/>
                    <col className={css.colOrigen}/>
                </colgroup>
                <thead>
                    <tr>
                        <th className={css.thRut}>Rut</th>
                        <th className={css.thNombre}>Nombre</th>
                        <th className={css.thColacion}>Colación</th>
                        <th className={css.tdViatico}>Viático 100%</th>
                        <th className={css.tdViatico}>Viático 50%</th>
                        <th className={css.thOrigen}>Origen 1</th>
                        <th className={css.thOrigen}>Origen 2</th>
                    </tr>
                </thead>
                <tbody>
                    {children}
                </tbody>
            </table>
        </div>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/admin/lider-detalles/TablaLiderDetalles.jsx